import type { JSX } from 'solid-js';
import { t } from '../i18n';
import { createElementWidth } from '../lib/element-width';
import type { FleetLiveModel } from '../lib/fleet-live';
import type { LiveLoop } from '../lib/fleet-live-loop';
import { topoLayout } from '../lib/fleet-live-topology';
import { createTopoPainter } from '../lib/fleet-live-topology-paint';
import { FleetLiveCanvas } from './FleetLiveCanvas';
import { FleetLiveLegend, type LegendEntry } from './FleetLiveLegend';
import { FleetLiveText } from './FleetLiveText';

// The Topology's body (#6778, prototype `:3511-3516`): its canvas, its text alternative
// (with the three node counts), and ITS OWN legend, "Work in flight / Parked at intake /
// CI failed, going back / Shipping" (owner ruling V9 #2), never the deck's.

const LEGEND: readonly { tone: LegendEntry['tone']; key: () => string }[] = [
  { tone: 'live', key: () => t('fleet.live.topo_legend_flight') },
  { tone: 'parked', key: () => t('fleet.live.topo_legend_parked') },
  { tone: 'red', key: () => t('fleet.live.topo_legend_ci') },
  { tone: 'shipped', key: () => t('fleet.live.topo_legend_shipping') },
];

export function FleetLiveTopology(props: {
  readonly model: FleetLiveModel;
  readonly loop: LiveLoop;
}): JSX.Element {
  const wrap = createElementWidth(() => props.loop.invalidate());
  const painter = createTopoPainter();
  return (
    <>
      <div class="fleet-live__canvas-wrap" ref={(el) => wrap.attach(el)}>
        <FleetLiveCanvas
          label={t('fleet.live.topology_canvas')}
          loop={props.loop}
          width={wrap.width}
          height={(w) => topoLayout(w, props.model.machines.length).h}
          paint={(ctx, p, w, f) =>
            painter.paint(ctx, {
              l: topoLayout(w, props.model.machines.length),
              p,
              model: props.model,
              motion: f.motion,
              now: f.now,
              dt: f.dt,
            })
          }
        />
        <FleetLiveText model={props.model} nodes />
      </div>
      <FleetLiveLegend entries={LEGEND.map((e) => ({ tone: e.tone, label: e.key() }))} />
    </>
  );
}
